// extracted by mini-css-extract-plugin
export default {"root":"badgeStyles_root__VnmCM"};